import axios from 'axios';
import AppModels from 'BaseModels/AppModels'

class AppModelModel extends AppModels {


}

export default AppModelModel;
